import { atom } from "jotai";
import activeWindowAtom from "./activeWindowAtom";
import openedWindowIdsAtom from "./openedWindowIdsAtom";
import openedWindowsAtom from "./openedWindowsAtom";
import { activeWindowHistoryAtom } from "./activeWindowHistoryAtom";
// import { componentStorage } from "./getWindowAtom";

const closeWindowAtom = atom(null, (get, set, windowId: string) => {
  const activeId = get(activeWindowAtom);
  const history = get(activeWindowHistoryAtom);
  const opened = get(openedWindowsAtom);

  // Remove from history first
  const newHistory = history.filter((id) => id !== windowId);
  set(activeWindowHistoryAtom, newHistory);

  // Remove the window from open lists
  // componentStorage.removeItem(windowId);
  set(openedWindowIdsAtom, (ids) => ids.filter((id) => id !== windowId));

  // If it's not the active window → Done.
  if (activeId !== windowId) return;

  // Find last previously active window still open
  const nextActive = [...newHistory].reverse().find((id) => opened[id]);

  set(activeWindowAtom, nextActive ?? null);
});

export default closeWindowAtom;
